// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"847ee7ae","76":"d7972e6a","223":"3ac2500a","329":"f75ae8dc","366":"b06f4d12","480":"33c6f376","482":"1d9bc0e0","496":"600119a8","681":"070032b6","787":"07bdd995","845":"7040e803","846":"880ecaa4","938":"5f3c52e2","975":"a3474fb9"}[chunkId] + ".chunk.js";
};